module.exports = __webpack_public_path__ + "static/media/groomingPageNailIcon.c1f306d0.png";